import React, { Component, useRef } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  UncontrolledTooltip,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu
} from 'reactstrap';
import ReactToPrint from 'react-to-print';
import { saveAs } from 'file-saver';
import QRCode from 'qrcode-react';

import apiUrlConfig from 'configs/apiUrlConfig';
import ToolTip from '../components/Tooltip';
class QrcodeToPrint extends Component {
  render() {
    const { qrurl } = this.props
    return (
      <div className="survey-qrcode">
        <img src={`${qrurl}`} width="400" height="400" />
      </div>
    );
  }
}

class QRCodeButton extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  downloadqrgen = qrCodeImageUrl => {
    saveAs(`${qrCodeImageUrl}?${new Date()}`, 'QrCode.png');
  };

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }
  render() {
    const { title, icon, customSurvey } = this.props;
    const { dropdownOpen } = this.state;
    const { survey_token, qr_code_url } = customSurvey;
    const btnText = title || "QR Code";

    return (
      <Dropdown isOpen={dropdownOpen} toggle={this.toggle}>
        <DropdownToggle id={`qd${survey_token}`} className="btn-outline-secondary btn-sm mr-1 mb-1">
          {icon && <FontAwesomeIcon icon="download" />}
          {btnText}
        </DropdownToggle>
        <ToolTip
          title={"Survey QR Code"}
          placement="bottom"
          hidden={dropdownOpen}
          target={`qd${survey_token}`}
        />
        <DropdownMenu
          className="pl-2 pr-2 qr-code-drop-down-menu"
        >
          <DropdownItem header className="pl-0 pt-0 pb-0">
            QR Code
          </DropdownItem>

          <div id={`d${survey_token}`} className="custom-survey-promote-icon-container">
            <a
              onClick={() => this.downloadqrgen(`${qr_code_url}`)}
            >
              <FontAwesomeIcon
                icon="download"
                size="xs"
              />
              Download
            </a>
            <UncontrolledTooltip
              placement="right"
              target={`d${survey_token}`}
              className="custom-survey-icon-tool-tip"
            >
              Download QrCode Image
            </UncontrolledTooltip>
          </div>
          <div id={`p${survey_token}`} className="custom-survey-promote-icon-container">
            <ReactToPrint
              trigger={() => (
                <a>
                  <FontAwesomeIcon
                    icon="print"
                    size="xs"
                  />Print
                </a>
              )}
              content={() => this.componentRef}
            />
            <UncontrolledTooltip
              placement="right"
              target={`p${survey_token}`}
              className="custom-survey-icon-tool-tip"
            >
              Print QrCode
            </UncontrolledTooltip>
          </div>
          <div className="qr-code-print-div">
            <QrcodeToPrint
              qrurl={`${qr_code_url}`}
              ref={el => (this.componentRef = el)}
            />
          </div>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

QRCodeButton.propTypes = {
  qrurl: PropTypes.string,
  customSurvey: PropTypes.object
};

export default QRCodeButton;



// WEBPACK FOOTER //
// ./src/utils/QRCodeButton.js